

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 
 const DeleteOperatorFromRole = (data: any) =>
 request({
   url: ApiURL.Command.DeleteOperatorFromRole,
   method: RequestType.POST,
   data,
 });
const PutOperatorUpdate = (data: any) =>
request({
  url: ApiURL.Command.PutOperatorUpdate,
  method: RequestType.PUT,
  data,
});
//#region Mock Data (Json Server)

const PostOperatorCreate = (data: any) =>
request({
  url: ApiURL.Command.PostOperatorCreate,
  method: RequestType.POST,
  data,
});
const PostAddOperatorToRole = (data: any) =>
request({
  url: ApiURL.Command.PostAddOperatorToRole,
  method: RequestType.POST,
  data,
});
const PostCreateRole = (data: any) =>
request({
  url: ApiURL.Command.PostCreateRole,
  method: RequestType.POST,
  data,
});

const PutUpdateRole = (data: any) =>
request({
  url: ApiURL.Command.PutUpdateRole,
  method: RequestType.PUT,
  data,
});
const PostRoleAuthorizationAdd = (data: any) =>
request({
  url: ApiURL.Command.PostRoleAuthorizationAdd,
  method: RequestType.POST,
  data,
});

const PostRoleAuthorizationBulkAdd = (data: {
  authorizedRoute: string;
  privilegeBinary: string;
  roleIds: number[];
}) =>
request({
  url: ApiURL.Command.PostRoleAuthorizationBulkAdd,
  method: RequestType.POST,
  data,
  skipErrorModal: true,
});
const DeleteRole = (data: any) =>
request({
  url: ApiURL.Command.DeleteRole+"/"+data+"/delete",
  method: RequestType.DELETE,
});

const DeleteRoleAuthorization = (data: any) =>
request({
  url: ApiURL.Command.DeleteRoleAuthorization+"/"+data+"/delete",
  method: RequestType.DELETE,
});
const UpdateApplicationUser = (data: any) =>
request({
  url: ApiURL.Command.UpdateApplicationUser,
  method: RequestType.POST,
  data,
});
const UpdateHarmonyData = (data: any) =>
request({
  url: ApiURL.Command.UpdateHarmonyData,
  method: RequestType.POST,
  data,
});
const UpdateOperatorIdData = (data: any) =>
request({
  url: ApiURL.Command.UpdateOperatorIdData,
  method: RequestType.POST,
  data,
});
const GetOperatorsByOperatorId = (data: any) =>
request({
  url: ApiURL.Command.GetOperatorsByOperatorId,
  method: RequestType.POST,
  data,
});

const TransferRole = (data: any) =>
request({
  url: ApiURL.Command.TransferRole,
  method: RequestType.POST,
  data,
});

const OperatorCommand = {
  DeleteOperatorFromRole,
  PutOperatorUpdate,
  PostOperatorCreate, 
  PostAddOperatorToRole,
  PostCreateRole,
  PutUpdateRole,
  DeleteRole,
  PostRoleAuthorizationAdd,
  PostRoleAuthorizationBulkAdd,
  DeleteRoleAuthorization,
  UpdateApplicationUser,
  UpdateHarmonyData,
  GetOperatorsByOperatorId,
  UpdateOperatorIdData,
  TransferRole
};

export default OperatorCommand;
